import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { DecisionRefundContent } from '@/components/tax-refund/individual/DecisionRefund/Result/DecisionRefundContent';

const DecisionRefundNonePage = () => {
  return (
    <AuthGuard>
      <Layout>
        <DecisionRefundContent
          graphic={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_document-mag_md.svg`} className={'w-20 h-20'} alt={'document-mag'} />}
          title={`아직 국세청에서\n신고서 검토 중이에요`}
          description={`신고 후 2개월 이상 소요될 수 있어요.\n환급까지 조금만 더 기다려주세요.`}
        />
      </Layout>
    </AuthGuard>
  );
};

export default DecisionRefundNonePage;
